/**
 * 格式化数字，添加千位分隔符
 * @param {number|null|undefined} num - 要格式化的数字
 * @returns {string} 格式化后的字符串
 */
export function formatNumber(num) {
  if (num === null || num === undefined) return '0';
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/**
 * 将完整数字转换为"x.xx亿"或"x.xx万"这样的格式
 * @param {number|null|undefined} num - 要转换的数字
 * @returns {string} 转换后的字符串
 */
export function formatFinancialNumber(num) {
  if (num === null || num === undefined) return '0';
  
  // 处理负数
  const isNegative = num < 0;
  const absNum = Math.abs(num);
  
  let result = '';
  
  if (absNum >= 100000000) { // 大于等于1亿
    result = (absNum / 100000000).toFixed(2) + '亿';
  } else if (absNum >= 10000) { // 大于等于1万
    result = (absNum / 10000).toFixed(2) + '万';
  } else {
    result = absNum.toString();
  }
  
  // 如果是负数，添加负号
  return isNegative ? '-' + result : result;
}

/**
 * 根据评分获取对应的CSS类名
 * @param {number} score - 评分值
 * @returns {string} 对应的CSS类名
 */
export function getRankingScoreClass(score) {
  if (score === 0) {
    return 'score score-0';
  } else if (score > 0 && score <= 1) {
    return 'score score-0-1';
  } else if (score > 1 && score <= 2) {
    return 'score score-1-2';
  } else if (score > 2 && score <= 3) {
    return 'score score-2-3';
  } else if (score > 3 && score <= 4) {
    return 'score score-3-4';
  } else if (score > 4 && score < 5) {
    return 'score score-4-5';
  } else if (score === 5) {
    return 'score score-5';
  }
  return '';
}

/**
 * 根据股票代码获取价格精度
 * @param {string} stockCode - 股票代码
 * @returns {number} 价格精度（小数点后位数）
 */
export function getPricePrecision(stockCode) {
  // 如果股票代码长度为5，返回3位小数
  if (stockCode.length === 5) {
    return 3;
  } else if (stockCode.startsWith('11')
   || stockCode.startsWith('11')
   || stockCode.startsWith('12')
   || stockCode.startsWith('12')
   || stockCode.startsWith('12')
  ) {
    // 可转债
    return 3;
  } else if (stockCode.startsWith('15')
   || stockCode.startsWith('16')
   || stockCode.startsWith('51')
   || stockCode.startsWith('58')
  ) {
    // ETF
    return 3;
  } else {
    return 2;
  }
}